import { SaleStatus } from '@/types/api/sale';

export const saleStatusNameColorMapping = {
  [SaleStatus.Planned]: 'text-blue-500', // Blue for confirmed
  [SaleStatus.Active]: 'text-green-500',
  [SaleStatus.Completed]: 'text-green-700', // Darker green for completed
  [SaleStatus.Cancelled]: 'text-red-500', // Darker green for completed
};

export const saleStatusNameMapping = {
  [SaleStatus.Active]: 'Pågående',
  [SaleStatus.Planned]: 'Kommande',
  [SaleStatus.Completed]: 'Avslutad',
  [SaleStatus.Cancelled]: 'Avbruten',
};

export const saleStatusBackgroundColorMapping = {
  [SaleStatus.Planned]: 'bg-blue-500/20 text-blue-700',
  [SaleStatus.Active]: 'bg-green-500/20 text-green-700',
  [SaleStatus.Completed]: 'bg-green-700/20 text-green-900',
  [SaleStatus.Cancelled]: 'bg-red-500/20 text-red-700',
};
